export default __webpack_public_path__ + "static/media/Prospect-Illustration.c1906fa2.svg";